export const actions = {
    SET_NAME: "SET_NAME",
}

export const setName = ( profile ) => {
    return {
        type: actions.SET_NAME,
            personId: profile.id,
            first: profile.first_name,
            last: profile.last_name,
    }
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/name.js